import React, { useState } from 'react';

import { Button } from '@components/Button';
import { TradeConditionDialog } from '@components/utilities/BookingInquiry/TradeConditionDialog';
import { bookingInquiryStrings, bookingInquiryTradeConditionStrings } from '@data/bookingInquiry';
import { TradeCondition } from '@models/BookingInquiry';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { formStrings, useErrorMessage } from '@utils/forms';
import { createStrings } from '@utils/local';
import clsx from 'clsx';
import { useField } from 'formik';

const strings = createStrings({
  ja: {
    selectTradeCondition: '貿易条件を選択',
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  valueDisplayEdit: {
    ...common.textGray800,
    backgroundColor: theme.palette.grey[50],
    padding: 8,
  },
}));

export interface TradeConditionSelectorProps {
  name: string;
  hasPickupsFieldName: string;
}

export const TradeConditionSelector: React.FC<TradeConditionSelectorProps> = (props) => {
  const { name, hasPickupsFieldName } = props;

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const [dialogOpen, setDialogOpen] = useState(false);
  const [field] = useField<TradeCondition | ''>(name);
  const [hasPickupsField] = useField<'true' | 'false'>(hasPickupsFieldName);
  const error = useErrorMessage(name);

  const tradeConditionLabel = field.value && bookingInquiryTradeConditionStrings[field.value];

  return (
    <div className={classes.middleText}>
      <TradeConditionDialog
        name={name}
        hasPickupsFieldName={hasPickupsFieldName}
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />

      {!tradeConditionLabel && (
        <Button
          type="button"
          text={strings.selectTradeCondition}
          color="primary"
          size="small"
          shape="round"
          onClick={() => setDialogOpen(true)}
        />
      )}

      {tradeConditionLabel && (
        <div className={classes.valueDisplayEdit}>
          <span>
            {tradeConditionLabel} (
            {hasPickupsField.value === 'false'
              ? bookingInquiryStrings.noPickup
              : bookingInquiryStrings.needsPickup}
            )
          </span>

          <span
            className={clsx(classes.link, classes.floatRight)}
            onClick={() => setDialogOpen(true)}
          >
            {formStrings.change}
          </span>
        </div>
      )}

      {error != null && (
        <>
          <div style={{ height: '1rem' }} />
          <div className={clsx(classes.textError, classes.smallerText)}>{error ?? 'Error'}</div>
        </>
      )}
    </div>
  );
};
